export default {
    ADMIN: 'ADMIN',
    MANAGER: 'MANAGER',
    ANALYST: 'ANALYST',
    REVIEWER: 'REVIEWER',
    USER: 'USER',
    DEACTIVATED: 'DEACTIVATED'
};
